/**
 * 获取时间为多久前
 * （1）调用：friendlyFormatTime('2021-12-22 17:42:09')
 * （2）stringTime：yyyy-mm-dd HH:mm:ss
 **/
export function friendlyFormatTime(stringTime) {
  let str = stringTime;
  //将字符串转换成时间格式
  let timePublish = new Date(str);
  let timeNow = new Date();
  let minute = 1000 * 60;
  let hour = minute * 60;
  let day = hour * 24;
  let month = day * 30;
  let year = month * 12;
  let diffValue = timeNow - timePublish;
  let diffMonth = diffValue / month;
  let diffWeek = diffValue / (7 * day);
  let diffDay = diffValue / day;
  let diffHour = diffValue / hour;
  let diffMinute = diffValue / minute;
  let diffYear = diffValue / year;
  let result = null;
  if (diffValue < 0) {
    result = "刚刚";
  } else if (diffYear > 1) {
    result = parseInt(diffYear) + "年前";
  } else if (diffMonth > 1) {
    result = parseInt(diffMonth) + "月前";
  } else if (diffWeek > 1) {
    result = parseInt(diffWeek) + "周前";
  } else if (diffDay > 1) {
    result = parseInt(diffDay) + "天前";
  } else if (diffHour > 1) {
    result = parseInt(diffHour) + "小时前";
  } else if (diffMinute > 1) {
    result = parseInt(diffMinute) + "分钟前";
  } else {
    result = "刚刚";
  }
  return result;
}

/**
 * 获取当前时间
 * （1）调用：getNowDate(type)
 * （2）YMD:day/month/min/second 分别获取到日期、月份、分钟、秒
 * （3）supplement:true(补0)/false(不补0)
 **/
export function getNowDate(YMD, supplement = true) {
  var nowDate = new Date();
  var Year = nowDate.getFullYear();
  if (supplement) {
    var Month =
      nowDate.getMonth() + 1 > 9
        ? nowDate.getMonth() + 1
        : "0" + (nowDate.getMonth() + 1);
    var dates =
      nowDate.getDate() > 9 ? nowDate.getDate() : "0" + nowDate.getDate();
    var hour =
      nowDate.getHours() > 9 ? nowDate.getHours() : "0" + nowDate.getHours();
    var min =
      nowDate.getMinutes() > 9
        ? nowDate.getMinutes()
        : "0" + nowDate.getMinutes();
    var second =
      nowDate.getSeconds() > 9
        ? nowDate.getSeconds()
        : "0" + nowDate.getSeconds();
  } else {
    var Month = nowDate.getMonth() + 1;
    var dates = nowDate.getDate();
    var hour = nowDate.getHours();
    var min = nowDate.getMinutes();
    var second = nowDate.getSeconds();
  }
  if (YMD == undefined || YMD == "day") {
    return Year + "-" + Month + "-" + dates;
  } else if (YMD == "month") {
    return Year + "-" + Month;
  } else if (YMD == "hour") {
    return Year + "-" + Month + "-" + dates + " " + hour;
  } else if (YMD == "min") {
    return Year + "-" + Month + "-" + dates + " " + hour + ":" + min;
  } else if (YMD == "second") {
    return (
      Year + "-" + Month + "-" + dates + " " + hour + ":" + min + ":" + second
    );
  } else {
    return Year;
  }
}

/**
 * 获取指定日期的前几天或后几天
 * （1）调用：getLastDate("2018-09-27",-1)
 **/
export function getLastDate(date, day) {
  let newDate = date.split(" ");
  let dd = new Date(newDate[0]);
  dd.setDate(dd.getDate() + day);
  let y = dd.getFullYear();
  let m =
    dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
  let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
  if (newDate[1]) {
    return y + "-" + m + "-" + d + " " + newDate[1];
  } else {
    return y + "-" + m + "-" + d;
  }
}

/**
 * 获取传入时间的上一个月\下一个月
 * （1）调用：getFollowMonth(date,type)
 * （2）date:格式为yyyy-mm-dd的日期，如：2014-01-25
 * （3）type:1（下一个月）/-1（上一个月）
 * （4）supplement:true(补0)/false(不补0)
 **/
export function getFollowMonth(date, type, supplement = true) {
  var arr = date.split("-");
  var year = arr[0]; //获取当前日期的年份
  var month = arr[1]; //获取当前日期的月份
  var day = arr[2] ? arr[2] : ""; //获取当前日期的日
  if (day) {
    var days = new Date(year, month, 0);
    days = days.getDate(); //获取当前日期中月的天数
  }

  var year2 = year;
  if (type === 1) {
    var month2 = parseInt(month) + 1;
    if (month2 == 13) {
      year2 = parseInt(year2) + 1;
      month2 = 1;
    }
    if (day) {
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
    }

    if (supplement) {
      if (month2 < 10) {
        month2 = "0" + month2;
      }
    }
    if (day) {
      var t2 = year2 + "-" + month2 + "-" + day2;
    } else {
      var t2 = year2 + "-" + month2;
    }
  } else {
    var month2 = parseInt(month) - 1;
    if (month2 == 0) {
      year2 = parseInt(year2) - 1;
      month2 = 12;
    }
    if (day) {
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
    }
    if (supplement) {
      if (month2 < 10) {
        month2 = "0" + month2;
      }
    }
    if (day) {
      var t2 = year2 + "-" + month2 + "-" + day2;
    } else {
      var t2 = year2 + "-" + month2;
    }
  }
  return t2;
}

/**
 * 获取当前时间的上一年
 * （1）调用：getPreYear('2021-12-22')
 **/
export function getPreYear() {
  var nowDate = new Date();
  var Year = nowDate.getFullYear();
  var Month =
    nowDate.getMonth() + 1 > 9
      ? nowDate.getMonth() + 1
      : "0" + (nowDate.getMonth() + 1);
  var dates =
    nowDate.getDate() > 9 ? nowDate.getDate() : "0" + nowDate.getDate();
  var lastYear = Year - 1;
  var LastYearDate = lastYear + "-" + Month + "-" + dates;
  return LastYearDate;
}

/**
 * 将数组中相同的元素进行分组
 * （1）调用：arrayGroup(需要分类的数组,分类的字段名)
 * （2）date:需要分类的数组
 * （3）field:分类的字段名，根据这个字段名进行分类
 * （4）backArr:是否返回带有分类名和数量等详细信息的数组
 *
 **/
export function arrayGroup(data, field, backArr = false) {
  const groupBy = (array, f) => {
    let groups = {};
    array.forEach((o) => {
      let group = JSON.stringify(f(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map((group) => {
      return groups[group];
    });
  };
  const sorted = groupBy(data, (item) => {
    return item[field]; // 返回需要分组的对象
  });

  let fieldArr = [];
  fieldArr.push({
    name: "全部",
    data: data,
    count: data.length,
  });
  sorted.forEach((item) => {
    let getArr = item[0];
    fieldArr.push({
      name: getArr[field],
      data: item,
      count: item.length,
    });
  });

  if (backArr) {
    //data:单纯分类的数组  backArr:分类且带详细信息  originalArr：处理前的原数组
    return {
      data: sorted,
      backArr: fieldArr,
      originalArr: data,
    };
  } else {
    return sorted;
  }
}

export function dealMenu(list, first, filter) {
  if (!list || list.length < 1) {
    return [];
  } else {
    let newList = JSON.parse(JSON.stringify(list));
    let newFilter = null;
    if (filter) {
      newFilter = filter.replace("/", "");
    }

    function deal(list, first, filter) {
      list.forEach((item, index, arr) => {
        if (filter && item.path.replace("/", "") == newFilter) {
          arr.splice(index, 1);
        } else if (item.children && item.children.length > 0) {
          arr[index] = {
            name: item.meta ? item.meta.title : "",
            icon: item.meta ? item.meta.icon : "",
            hidden: item.hidden,
            router: first ? first + "/" + item.path : item.path,
            children: item.children,
          };
          deal(item.children, arr[index].router);
        } else {
          arr[index] = {
            name: item.meta ? item.meta.title : "",
            icon: item.meta ? item.meta.icon : "",
            hidden: item.hidden,
            router: first ? first + "/" + item.path : item.path,
            children: item.children,
          };
        }
      });
    }
    deal(newList, first, filter);
    return newList;
  }
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children",
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
 * 清除elementForm表单验证，弹窗打开时使用
 **/
export function clearValidate(formName) {
  this.$nextTick(() => {
    this.$refs[formName].clearValidate();
    // this.$refs[formName].resetFields();
  });
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

/*
  获取URL中的参数
  name:参数名
*/
export function getParams(name) {
  var search = window.location.search.substring(1);
  if (!search) {
    search = window.location.hash.split("?")[1];
  }
  if (search) {
    var obj = JSON.parse(
      '{"' +
        decodeURIComponent(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    );
    return name ? obj[name] : obj;
  }
}
